<template>
  <div style="display: contents">
    <slot />
    <Lightbox :service="lightboxService" />
  </div>
</template>

<script lang="ts">
import { defineComponent, provide } from "vue"
import { LightboxService } from "features/gallery/lightbox/lightbox.service"
import Lightbox from "features/gallery/lightbox/Lightbox.vue"

export default defineComponent({
  name: "LightBoxProvider",
  components: { Lightbox },
  setup() {
    const lightboxService = new LightboxService()
    provide("lightboxService", lightboxService)

    return {
      lightboxService,
    }
  },
})
</script>
